export default class {
  constructor(container, modal, photos, fetchPhotos) {
    this.container = container;
    this.modal = modal;
    this.photos = photos;
    this.fetchPhotos = fetchPhotos;
  }

  bindEvents() {
    this.container.addEventListener("mouseover", (e) => {
      let closestPhoto = e.target.closest(".l2h-photowrap:not(.l2h-force-default-click)");
      if (closestPhoto) {
        closestPhoto.classList.add("hover");
      }
    });

    this.container.addEventListener("mouseout", (e) => {
      let closestPhoto = e.target.closest(".l2h-photowrap:not(.l2h-force-default-click)");
      if (closestPhoto) {
        closestPhoto.classList.remove("hover");
      }
    });

    this.container.addEventListener("click", (e) => {
      if (e.target.closest(".l2h-ico-close")) {
        this.closeCallback();
      }

      let closestPhoto = e.target.closest(".l2h-photowrap:not(.l2h-force-default-click)");
      if (closestPhoto) {
        this.selectedPhotoIdx = this.photos.findIndex(photo => photo.id == closestPhoto.dataset.id);
        let selectedPhoto = this.photos[this.selectedPhotoIdx]
        this.setPhoto(selectedPhoto);
        this.modal.open();
        e.preventDefault();
      }
    });

    this.modal.addEventListener("l2h-modal-close", (e) => { });
    this.modal.addEventListener("l2h-modal-next", (e) => { this.nextPhoto(); });
    this.modal.addEventListener("l2h-modal-prev", (e) => { this.prevPhoto(); });

    return this;
  }

  setPhoto(photo) {
    this.modal.photo = photo;

    if (this.selectedPhotoIdx === (this.photos.length - 1)) {
      this.modal.disableNextBtn();

      if (this.fetchPhotos) {
        this.fetchPhotos().then(() => {
          if (this.selectedPhotoIndex < (this.photos.length -1)) {
            this.modal.enableNextBtn();
          }
        });
      }
    }

    if (this.selectedPhotoIdx === 0) {
      this.modal.disablePrevBtn();
    } else {
      this.modal.enablePrevBtn();
    }
  }

  nextPhoto() {
    const photo = this.photos[this.selectedPhotoIdx + 1];

    if (photo != null) {
      this.selectedPhotoIdx++;
      this.setPhoto(photo);
    }
  }

  prevPhoto() {
    if (this.selectedPhotoIdx > 0) {
      this.selectedPhotoIdx--;
      const photo = this.photos[this.selectedPhotoIdx];
      this.setPhoto(photo);
    }
  }
}
